<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/investor-relations/shareholder-information/dividend-drip-policies',
    'fr-CA': '/relations-avec-investisseurs/section-investisseurs/politiques-relatives-aux-dividendes-au-prd'
  }
})

useHead({
  title: t('navigation.dividendDripPolicies.metatitle'),
  meta: [{ name: 'description', content: t('navigation.dividendDripPolicies.metadescription') }]
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-investorRelations')">{{ $t('navigation.investorRelations.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-shareholderInformation')">{{ $t('navigation.shareholderInformation.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.dividendDripPolicies.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.dividendDripPolicies.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuInvestorRelations />
        <div class="contenu right">
          <div v-if="$i18n.locale == 'en-CA'"
               class="">
            <h2>Dividend policy of KP Tissue Inc.</h2>
            <p>Dividends on the common shares of KP Tissue Inc. (KPT) are declared at the discretion of the Board of Directors. There can be no guarantee of dividends and KPT can change its dividend policy at any time.</p>
            <p>It is the intention of KPT that all regular distributions received from Kruger Products Inc. (other than amounts distributed to KPT to enable it to discharge any federal and provincial income taxes) be distributed to shareholders on an ongoing basis.</p>
            <h2>Dividend reinvestment plan of KP Tissue Inc.</h2>
            <p>The dividend reinvestment plan (DRIP) of KPT offers shareholders the opportunity to automatically reinvest their cash dividends in common shares of KPT at no cost. This provides two advantages:</p>
            <p>Shareholders can increase their investment in KPT in relatively small, affordable lots without incurring investment-related expenses such as commission fees; and</p>
            <p>Shareholders can incrementally distribute their share purchases over time, in keeping with the widely accepted investment principle of dollar-cost averaging.</p>
            <p>
<a class="btn"
                 name="hyperlien"
                 href="/documents/kp-tissue-drip-corporation-dec12-23.pdf"
                 target="_blank">Dividend Reinvestment Plan</a>
</p>
          </div>
          <div v-if="$i18n.locale == 'fr-CA'"
               class="">
            <h2>Politique de Papiers Tissu KP Inc. sur les dividendes</h2>
            <p>Les dividendes sur les actions ordinaires de Papiers Tissu KP Inc. (la société) sont déclarés à la discrétion du conseil d'administration. Il ne peut y avoir de garantie de dividendes et la société peut changer sa politique à tout moment.</p>
            <h2>Programme de réinvestissement des dividendes de Papiers Tissu KP</h2>
            <p>Le programme de réinvestissement des dividendes (PRD) de Papiers Tissu KP donne aux actionnaires la possibilité de réinvestir d'office leurs dividendes en espèces, dans des actions ordinaires de la société, et ce sans frais. Cela procure deux avantages:</p>
            <ul>
              <li>Les actionnaires peuvent augmenter leur investissement dans la société avec des montants relativement petits et abordables sans engager de frais relatifs à l'investissement, tels que des frais de commission; et</li>
              <li>Les actionnaires peuvent répartir progressivement au fil du temps leurs achats d'actions conformément au programme, largement accepté, d'achats périodiques par sommes fixes.</li>
            </ul>
            <p>
<a class="btn"
                 href="/documents/kp-tissue-drip-corporation-dec12-23.pdf"
                 target="_blank">Programme de réinvestissement des dividendes</a>&nbsp;<span class="caption"><em>(Anglais seulement)</em></span>
</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
